<!--  -->
<template>
  <div
    :class="['training', 'training-blockly-content', { mark: beMark }]"
    @blur="componetsBlur"
  >
    <div class="training-head"></div>
    <Training-head
      :project-id="Project.projectId"
      :training-id="trainingId"
      :editor-type="editorType"
      trainingType="block"
      :scoreHandle="scoreHandle"
      @saveFile="saveFile"
    ></Training-head>
    <!-- :workspace-is-visible="workspaceIsVisible" -->
    <div class="training-area">
      <!-- :运行区模块 -->
      <div class="training-right-side">
        <Code-run
          v-show="rightSideVal == 'codeRun'"
          :codeText="codeText"
          @runHandle="runHandle"
          @sidebarSwitchHandle="sidebarSwitchHandle"
          ref="codeRun"
          v-bind="$attrs"
          v-on="$listeners"
        />
        <!-- 实训指导书 -->
        <ai-guide-book
          v-show="rightSideVal == 'guideBook'"
          @sidebarSwitchHandle="sidebarSwitchHandle"
          ref="guideBook"
          v-bind="$attrs"
          v-on="$listeners"
          :trainingId="trainingId"
          :createBy="createBy"
        />
        <guide-tool :path="hashId"></guide-tool>
        <p class="switch-btn" @click="swichRightSide" title="运行区/指导书" v-show="sidebarSwitch">
          <img :src="switchIcon" />
        </p>
      </div>

      <!-- 提交代码、提交题面按钮 -->
      <Submit-code-exercise
        :scoreHandle="scoreHandle"
        :scoreTitle="scoreTitle"
        :Project="Project"
        :trainingId="trainingId"
        :studentId="studentId"
        :buildingBlocksTypeObj="buildingBlocksTypeObj"
        @submitCode="submitCode"
        @saveFile="saveFile"
        :homeWorkStatus="homeWorkStatus"
        @gethomeWorkStatus="gethomeWorkStatus"
      />

      <blockly-editer-index
        :project-id="Project.projectId"
        :training-id="trainingId"
        :blockXmlText="blockXmlText"
        :Media="Media"
        :xml-data="{
          name: Project.ProjectName,
          type: 1,
          path: Project.BlocksFileUrl,
        }"
        :save-flag="saveFlag"
        ref="blocklyIndex"
      >
      </blockly-editer-index>
    </div>
    <div class="popup-list popup-list3">
      <!-- 项目提醒 -->
      <gat-popup
        :class="['popup-remind', popupActive === 'remind' ? 'on' : 'off']"
        :title="'提醒'"
        :primary-button="'确定'"
        cancelButton="false"
        @cancel="cancelPopup"
        @confirm="cancelPopup"
      >
        <template v-slot:content>
          <span
            >请为自己创建的实训项目进行Python编程,编译成功后点击提交代码！</span
          >
        </template>
      </gat-popup>

      <!-- 离开时保存提示弹框 -->
      <gat-popup
        :class="[
          'popup-leave-save',
          popupActive === 'leave-save' ? 'on' : 'off',
        ]"
        :title="'是否保存项目？'"
        :primary-button="'确定'"
        :cancel-button="'否'"
        @cancel="confirmLeaveSave"
        @confirm="confirmLeaveSave(true)"
      >
        <template v-slot:content>
          <span></span>
        </template>
      </gat-popup>
    </div>
  </div>
</template>

<script>
import TrainingHead from '@/views/trainingCenter/components/trainingHead.vue'
// import trainingHead from '@/views/trainingCenter/AiEditor/components/trainingHead.vue'
import BlocklyEditerIndex from '@/components/blocklyEditor/EditorIndex.vue'
import SubmitCodeExercise from '@/views/trainingCenter/SubmitCodeExercise.vue'
import CodeRun from '@/components/blocklyEditor/common/codeRun.vue'
import aiGuideBook from '@/components/blocklyEditor/training/aiGuideBook.vue'
import GatPopup from '@/components/common/GatPopup'
import GuideTool from '@/components/guide/GuideTool.vue'
import { mapGetters } from 'vuex'
import { Websocket } from '@/assets/js/mixin/mixinWebsocket.js'
import { mixinTrainingHome } from '@/views/trainingCenter/mixinTrainingHome.js'
import bus from '@/utils/bus'
export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'BlocklyHome',
  components: {
    TrainingHead,
    BlocklyEditerIndex,
    GatPopup,
    CodeRun,
    aiGuideBook,
    SubmitCodeExercise,
    GuideTool,
  },
  mixins: [Websocket, mixinTrainingHome],
  props: ['trainingId', 'createBy'],
  metaInfo: {
    title: '国匠云人工智能应用软件-实训中心AIT编辑器',
    meta: [
      {
        name: 'keyWords',
        content: 'AIT编辑器,积木编辑器,可视化编程,blockly',
      },
      {
        name: 'description',
        content:
          'AI-Training实训平台的实训中心，可以建立一个实训主题（实训课程），然后构建不同类型的实训项目，比如可以建立通过python编辑器教学的项目，或者建立模型训练类型的项目进行一次实训研究或教学。',
      },
    ],
  },
  data() {
    return {
      Blocks: { TotalCount: 0, Items: [] },
      scoreHandle: false,
      studentId: '',
      workspaceIsVisible: true,
      sidebarSwitch: true,
      // homeWorkStatus: false,
      hashId: 'blockly-editor',
      beMark: false, //遮罩层
      hasAttr: false,
      scoreTitle: '实训评分',
      trainingDetails: { status: 2 }, // 需要从接口获取
      reportInfo: {}, //实训报告信息
      guideBookSwitch: {
        type: 'guideBook',
        sidebarSwitch: true,
      },
      codeRunSwitch: {
        type: 'codeRun',
        sidebarSwitch: true,
      },
      buildingBlocksType: 0, //保存的积木类型：1项目题解，2项目题面，3基础模型，4提交作业
      Media: [],
      Project: {
        //项目信息存储
        ProjectId: '00000000-0000-0000-0000-000000000000',
        ProjectName: 'AI 人形机器人',
        BlocksFileUrl: '',
      },
      blockXmlText: '',
      popupActive: '',
      searchKey: '',
      // 创建项目类别
      Category: {
        img01: require('../../../../public/images/img01.png'),
        img02: require('../../../../public/images/img02.png'),
      },
      MyProjectList: {
        PageSize: 10000, // TODO:暂全部显示
        Items: [],
      },
      NewProject: {
        ProjectId: '00000000-0000-0000-0000-000000000000',
        ProjectName: '新建项目',
        BlocksFileUrl: '',
      },
      Train: {},
      TrainId: '',
      routePath: '', //跳转的路由来源
      taskInfo: null, // 作业任务信息;
      submitObj: {
        //学生提交字段
        ProjectId: '', //项目id
        ProjectName: '', //项目名称
        ProjectContent: '', // 项目描述 ,
        points: '', //技能点
        presetGoal: '', //预设目标
        selfRatedScore: '', //自评分数;
      },
      buildingBlocksTypeObj: {
        //积木类型
        answer: 1, //1项目题解
        question: 2, //2项目题面
        save: 3, //3基础模型保存
        homework: 4, //4提交作业
      },
      saveFlag: 0, // 保存后没有修改，或打开后没有修改
      isComplete: 1, //1完成，0未完成
      isPublic: 1, //1完成，0未完成
      leaveType: '', //跳转的路由来源
      scored: null, //判断是否已评分状态进来
      score: null, //具体分数
      codeText: '', //运行结果，在runCode组件中处理;
      rightSideVal: 'guideBook',
      iconSubmitCode: require('@/assets/images/ai-editor/submit-code.png'),
      iconExercise: require('@/assets/images/ai-editor/submit-exercise.png'),
      switchIcon: require('@/assets/images/ai-editor/switch.png'),
      quoteTrainingId: '', // 引用实训模型id
    }
  },
  provide() {
    return {
      blockSData: this.Blocks,
    }
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapGetters(['accountInfo', 'hasRunSuccess', 'curriculumId', 'userRole']),
    status() {
      let Train = this.Train
      let val = Train.status
      return val
    },
  },
  //监控data中的数据变化
  watch: {},

  created() {
    this.quoteTrainingId = this.$route.query.quoteTrainingId || ''
  },

  async mounted() {
    let self = this,
      xmlText,
      projectInfoRes,
      taskRes

    //获取积木列表
    await this.getTrainingBlockList()
    bus.$emit('GetDefUserBlockList') //调用自定义积木列表
    //调用获取项目信息接口
    projectInfoRes = await this.getProjectInfo()
    taskRes = await this.getTaskInfoByTrainingId()
    console.log('scoreHandle', this.scoreHandle)
    if (this.scoreHandle) {
      //调用获取实训任务信息接口  
      projectInfoRes = taskRes
    }

    if (this.trainingId) {
      if (this.userRole != 2) {
        //老师角色 进入自己的实训时，工作台初始化显示最新保存的积木；
        xmlText = projectInfoRes.data.buildingBlocks
      } else if (this.userRole == 2) {
        /** 学生角色  优先显示：*/
        // if (taskRes && taskRes.data && taskRes.data.buildingBlocks) {
        //   xmlText = taskRes.data.buildingBlocks // 获取作业任务信息
        // } else
        if (
          projectInfoRes &&
          projectInfoRes.data &&
          projectInfoRes.data.buildingBlocks
        ) {
          //优先获取自己保存的积木
          xmlText = projectInfoRes.data.buildingBlocks
        }
      }

      if (projectInfoRes.data) {
        this.pythonEditorCode = projectInfoRes.data.pythonBlocks
      }

      //调用BlocklyEditer.vue工作台生成积木方法
      if (xmlText) {
        this.blockXmlText = xmlText
        // this.$emit('createBlocksByWorkspaceXML', xmlText, true)
      }
    }
  },
  beforeDestroy() {
    this.scoreHandle = false
    this.studentId = null
    this.$store.state.blocklyHome.studentId = null
    this.$store.state.blocklyHome.scoreHandle = null
    this.$store.state.blocklyHome.hasRunSuccess = null
    this.$store.state.blocklyHome.curriculumId = null
    this.$store.state.blocklyHome.homeWorkStatus = null
    this.$store.state.blocklyHome.Train = {}
    bus.$off('changeRightSide')
    bus.$off('changeWorkspace')
  },
  methods: {
    /**
     *
     *
     *@说明  methods逻辑主要通过mixinTrainingHome.js混入
     *
     *
     * */
  },
  updated() {}, //生命周期 - 更新之后
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
$head_height: 80px;
$blockly_editer_left: rgba(13, 22, 53, 0.5);
$blockly_editer_left_select: rgba(12, 21, 52, 0.9);
$bg_area_right: rgba(94, 147, 255, 0.1);
$bg_tool_button: rgba(103, 140, 255, 0.15);
$height_sidebar_item: calc(50% - 80px);
$high_ligth: #886efa;

.on {
  display: inline-block;
}

.off {
  display: none;
}

.popup-remind {
  z-index: 50;
  &.off {
    display: none;
  }
  &.on {
    display: inline-block;
  }
}

.popup-remind {
  &::v-deep .popup-inner {
    width: 580px;
    // height: 100%;
    // max-height: 90%;
    .popup-content {
      margin-top: 20px;
    }
  }
}
.training {
  min-height: 100%;
  height: 100%;
  background-color: #08102c;
  background-image: url('../../../../public/images/projects/bg_training.png');
  background-size: cover;
  background-position: center;
  color: $font_color_1st;
}

.training-area {
  // MARK:此处可能会有隐患
  overflow: hidden;
  position: relative;
  // min-height: 700px;
  height: calc(100% - 80px);

  // 代码模式
  &::v-deep .code-editer {
    color: #fff;
  }
}

.switch-btn {
  position: fixed;
  right: 345px;
  bottom: 38px;
  width: 36px;
  height: 36px;
  cursor: pointer;
  z-index: 50;
  img {
    width: 100%;
    height: 100%;
  }
}

.popup-list {
  .popup-leave-save,
  .popup-score {
    z-index: 50;
    &.off {
      display: none;
    }
  }
  .popup-score {
    &::v-deep .popup-inner {
      width: 620px;
      // height: 100%;
      height: 800px;
      max-height: 100%;
      .popup-content {
        .el-form {
          width: 90%;
          .el-form-item {
            margin-bottom: 5px;
            &.strong-label {
              .el-form-item__label {
                font-weight: 600;
              }
            }
          }
        }
        // .score-text {
        //   // margin-top: 20px;
        // }
      }
    }
    ::v-deep.popup-inner {
      max-height: 80%;
      height: 800px;
      .popup-content {
        padding-top: 20px;
      }
    }
  }
}
.dispermited {
  pointer-events: none;
  opacity: 0.5;
}
</style>
